import React, { useContext, useEffect } from 'react'
import deleteIcon from '../../images/png/deleteIcon.png'
import editIcon from '../../images/png/editIcon.png'

import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { CategorysContext } from '../../context/categorys'
import { MarkContext } from '../../context/mark'

const Image = styled.img`
    width: 28px;
    height:26px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`

const TableListMarks = ({ data, structure }) => {

    const { marks, getAll,setShowModalEdit,setModalEditValue,remove,setMarkName,setExibirModal} = useContext(MarkContext)

    useEffect(() => {
        getAll()
    }, [])

    return (
        <div className='container_startpn_table_categorys'>
            <table>

                <thead className='container_startpn_table_categorys'>
                    <tr>
                        {structure?.map((item, index) => {
                            return (
                                <td key={index}>{item.name}</td>

                            )
                        })}
                    </tr>
                </thead>


                <tbody className=''>
                    {String(marks).length == 0

                        ?
                        <tr>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>

                        </tr>
                        :

                        marks?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>#{item.id}</td>
                                    <td data-toggle="modal" data-target="">{item.name}</td>
                                    <td data-toggle="modal" data-target="" onClick={() => { setMarkName(item?.name);setModalEditValue(item.id);setExibirModal(true); }}><Image src={editIcon} /></td>
                                    <td data-toggle="modal" data-target="" onClick={() => remove(item.id)}> <Image src={deleteIcon} /></td>

                                </tr>
                            )
                        })}



                </tbody>
            </table>
        </div>
    )
}

export default TableListMarks